import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-directdebitsettings',
  templateUrl: './directdebitsettings.component.html',
  styleUrls: ['./directdebitsettings.component.css']
})
export class DirectdebitsettingsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
